// extracted by mini-css-extract-plugin
module.exports = {"module":"village-legend_module__SNcDo","item":"village-legend_item__jxiz9"};